import Start_Main_Start_Button from "./Start_Main_Start_Button";
import logo_google from "../../images/google.png";
import logo_apple from "../../images/apple.png";
import Start_Main_Or from "./Start_Main_Or";
import Start_Main_Start_Button_Image from "./Start_Main_Start_Button_Image";
import React from "react";

class Start_Main_Start_BtnSection extends React.Component {
    render() {
        return(
            <div className="start_main_start_btnSection">
                <Start_Main_Start_Button text="Sign up with Google" classButton="start_main_start_btnGoogle" image={<Start_Main_Start_Button_Image src={logo_google} alt="logo_google" />} classText="start_main_start_button_text_google" />
                <Start_Main_Start_Button text="Sign up with Apple" classButton="start_main_start_btnApple" image={<Start_Main_Start_Button_Image src={logo_apple} alt="logo_apple" />} classText="start_main_start_button_text_apple" />
                <Start_Main_Or />
                <Start_Main_Start_Button text="Sign up with a user name or email" classButton="start_main_start_btnSignUp" classText="start_main_start_button_text_signUp" path="/start/signup" />
                <p className="start_main_start_privacyText">By signing up, you agree to the <span>Terms</span> of <span>Service</span> and <span>Privacy Policy</span>, including <span>Cookie Use</span>.</p>
            </div>
        )
    }
}

export default Start_Main_Start_BtnSection;